import React, { Fragment, useEffect, useState } from 'react'
import Humberg from '../../../elements/Humberg';
import { useDispatch, useSelector } from 'react-redux';
import LoaderBlock from '../../loader/LoaderBlock';
import SingleOrder from './SingleOrder';
import DateFilter from '../../../elements/DateFilter';

import TopBarValues from './topBarValues';
import Filters from './Filters';
import { allProductTypesAction, clearErrors } from '../../../redux/actions/userActions';
import Loader from '../../loader/loader';
import { CREATE_ORDER_RESET } from '../../../redux/constants/orderConstants';



/*************  ✨ Windsurf Command 🌟  *************/
const AllOrders = () => {



    const dispatch = useDispatch()
    const { productTypes } = useSelector(state => state.allProductTypes);


    const { loading,
        orders,
        totalPages,
        orderedCount,
        reviewedCount,
        onHoldCount,
        deliveredCount,
        refundedCount,
        commissionedCount,
        completedCount,
        cancelledCount,
        reviewDeletedCount,
    } = useSelector((state) => state.orders)

    const { user } = useSelector(state => state.verifyEmailStore);
    const { loading: orderLoading, error, message } = useSelector(state => state.order)




    const [page, setPage] = useState('1');
    const [dateFrom, setDateFrom] = useState('');
    const [dateTo, setDateTo] = useState('');



    // Remove one quantity



    useEffect(() => {

        dispatch(allProductTypesAction())

    }, [dispatch])






    useEffect(() => {


        if (error) {
            dispatch(clearErrors())
        }

        if (message) {
            dispatch({ type: CREATE_ORDER_RESET })
        }

    }, [error, message, dispatch])





    return (
        <Fragment>
            {orderLoading && <Loader />}
            <Humberg header="Dashboard" headerLink="/" children={"Orders"} innerChildren={'All Orders'} />
            <DateFilter
                dateFrom={dateFrom}
                setDateFrom={setDateFrom}
                dateTo={dateTo}
                setDateTo={setDateTo}
            />



            <section className="p-[1.5vmax] mt-[1vmax]" >
                <TopBarValues
                    orderedCount={orderedCount}
                    reviewedCount={reviewedCount}
                    onHoldCount={onHoldCount}
                    deliveredCount={deliveredCount}
                    refundedCount={refundedCount}
                    commissionedCount={commissionedCount}
                    completedCount={completedCount}
                    cancelledCount={cancelledCount}
                    reviewDeletedCount={reviewDeletedCount}
                />






                <Filters page={page} setPage={setPage} dateFrom={dateFrom} dateTo={dateTo} />
                <div className="bg-white p-[2vmax] lg:mt-[-2vmax] shadow-1 rounded-b-lg overflow-x-auto premium-scrollbar pb-[15vmax]">

                    <div className="min-w-[2200px] mt-[2vmax] border border-gray-200 rounded-xl shadow-sm bg-white">
                        {/* Header */}
                        <div
                            className="grid bg-gray-50 py-[1vmax] items-center border-b border-gray-200 rounded-t-xl"
                            style={{
                                gridTemplateColumns: (user?.role === 'PMM' || user?.role === 'ADMIN' || user?.role === 'SUPER_ADMIN')
                                    ? 'minmax(0, 0.8fr) minmax(0, 1.5fr) minmax(0, 1.2fr) minmax(0, 1.5fr) minmax(0, 2.5fr) minmax(0, 0.8fr) minmax(0, 3fr) minmax(0, 0.8fr) minmax(0, 1fr) minmax(0, 2fr) minmax(0, 1.5fr) minmax(0, 1fr) minmax(0, 2.5fr)'
                                    : 'minmax(0, 0.8fr) minmax(0, 1.5fr) minmax(0, 1.5fr) minmax(0, 2.5fr) minmax(0, 0.8fr) minmax(0, 3fr) minmax(0, 0.8fr) minmax(0, 1fr) minmax(0, 2fr) minmax(0, 1.5fr) minmax(0, 1fr) minmax(0, 2.5fr)'
                            }}
                        >
                            <div className="text-center text-[#4c4c5c] uppercase text-[1.6vmax] lg:text-[0.8vmax] font-semibold" >
                                Order ID
                            </div>
                            {(user?.role === 'PMM' || user?.role === 'ADMIN' || user?.role === 'SUPER_ADMIN') &&
                                <div className="text-center text-[#4c4c5c] uppercase text-[1.6vmax] lg:text-[0.8vmax] font-semibold" >
                                    Seller
                                </div>
                            }
                            {(user?.role === 'PMM' || user?.role === 'ADMIN' || user?.role === 'SUPER_ADMIN') &&
                                <div className="text-center text-[#4c4c5c] uppercase text-[1.6vmax] lg:text-[0.8vmax] font-semibold" >
                                    Chinese Seller
                                </div>
                            }
                            {(user?.role === 'ADMIN' || user?.role === 'SUPER_ADMIN') &&
                                <div className="text-center text-[#4c4c5c] uppercase text-[1.6vmax] lg:text-[0.8vmax] font-semibold" >
                                    Ordered By
                                </div>
                            }
                            <div className="text-center text-[#4c4c5c] uppercase text-[1.6vmax] lg:text-[0.8vmax] font-semibold" >
                                Order Number
                            </div>
                            <div className="text-center text-[#4c4c5c] uppercase text-[1.6vmax] lg:text-[0.8vmax] font-semibold" >
                                Product
                            </div>
                            <div className="text-center text-[#4c4c5c] uppercase text-[1.6vmax] lg:text-[0.8vmax] font-semibold" >
                                Customer Email
                            </div>
                            <div className="text-center text-[#4c4c5c] uppercase text-[1.6vmax] lg:text-[0.8vmax] font-semibold" >
                                Market
                            </div>
                            <div className="text-center text-[#4c4c5c] uppercase text-[1.6vmax] lg:text-[0.8vmax] font-semibold" >
                                Product ID
                            </div>
                            <div className="text-center text-[#4c4c5c] uppercase text-[1.6vmax] lg:text-[0.8vmax] font-semibold" >
                                Product Type
                            </div>
                            <div className="text-center text-[#4c4c5c] uppercase text-[1.6vmax] lg:text-[0.8vmax] font-semibold" >
                                Ordered At
                            </div>
                            <div className="text-center text-[#4c4c5c] uppercase text-[1.6vmax] lg:text-[0.8vmax] font-semibold" >
                                Report
                            </div>
                            <div className="text-center text-[#4c4c5c] uppercase text-[1.6vmax] lg:text-[0.8vmax] font-semibold" >
                                Actions
                            </div>

                        </div>

                        {/* Rows */}
                        {loading ?
                            <LoaderBlock />
                            :
                            orders?.length > 0 ?
                                orders.map((order) => (
                                    <SingleOrder key={order.id} order={order} user={user} productTypes={productTypes} />
                                ))
                                :
                                <div className="text-center text-[1.5vmax] text-gray-400 py-[3vmax]" >
                                    No data found
                                </div>
                        }
                    </div>
                </div>
            </section>
            {totalPages > 1 && (
                <div className="flex gap-[1vmax] justify-center mt-[2vmax]">

                    {/* Prev button */}
                    <button
                        className="pagination-btn"
                        disabled={page === 1}
                        onClick={() => setPage(page - 1)}
                    >
                        Prev
                    </button>

                    {/* --- SMART PAGINATION START --- */}
                    {(() => {
                        const pages = [];
                        const maxVisible = 3; // number of pages to show around current page

                        const addPage = (p) => {
                            pages.push(
                                <button
                                    key={p}
                                    className={`pagination-btn ${page === p ? "active" : ""}`}
                                    onClick={() => setPage(p)}
                                >
                                    {p}
                                </button>
                            );
                        };

                        // Always show First Page
                        addPage(1);

                        // Left dots
                        if (page > maxVisible + 2) {
                            pages.push(<span key="dots-left">...</span>);
                        }

                        // Middle pages (dynamic)
                        for (
                            let p = Math.max(2, page - maxVisible);
                            p <= Math.min(totalPages - 1, page + maxVisible);
                            p++
                        ) {
                            addPage(p);
                        }

                        // Right dots
                        if (page < totalPages - (maxVisible + 1)) {
                            pages.push(<span key="dots-right">...</span>);
                        }

                        // Always show Last Page
                        if (totalPages > 1) {
                            addPage(totalPages);
                        }

                        return pages;
                    })()}
                    {/* --- SMART PAGINATION END --- */}

                    {/* Next button */}
                    <button
                        className="pagination-btn"
                        disabled={page === totalPages}
                        onClick={() => setPage(page + 1)}
                    >
                        Next
                    </button>

                </div>
            )}

            <br />
            <br />
            <br />
            <br />
        </Fragment>
    )
}

export default AllOrders